import React from "react";
import { compose } from "redux";
import connectActions from "fantastic/lib/connectActions";
import settingable from "fantastic/components/hoc/settingable";
import table from "fantastic/actions/table";

const CellSettings = ({
  selectedNode,
  addRightTableCell,
  addLeftTableCell,
  removeTableCell,
  addUpTableRow,
  addDownTableRow,
  removeTableRow
}) => {
  return (
    <>
      <div className="list-group">
        <button
          onClick={() => addRightTableCell(selectedNode.id)}
          className="list-group-item"
          type="button"
        >
          <i className="fa fa-arrow-right" />
          { i18n.t('table.add_right_column') }
        </button>
        <button
          onClick={() => addLeftTableCell(selectedNode.id)}
          className="list-group-item"
          type="button"
        >
          <i className="fa fa-arrow-left" />
          { i18n.t('table.add_left_column') }
        </button>
        <button
          onClick={() => removeTableCell(selectedNode.id)}
          className="list-group-item list-group-item-danger"
          type="button"
        >
          <i className="fa fa-remove" />
          { i18n.t('table.remove_column') }
        </button>
      </div>
      <div className="list-group">
        <button
          onClick={() => addUpTableRow(selectedNode.id)}
          className="list-group-item"
          type="button"
        >
          <i className="fa fa-arrow-up" />
          { i18n.t('table.add_top_row') }
        </button>
        <button
          onClick={() => addDownTableRow(selectedNode.id)}
          className="list-group-item"
          type="button"
        >
          <i className="fa fa-arrow-down" />
          { i18n.t('table.add_bottom_row') }
        </button>
        <button
          onClick={() => removeTableRow(selectedNode.id)}
          className="list-group-item list-group-item-danger"
          type="button"
        >
          <i className="fa fa-remove" />
          { i18n.t('table.remove_row') }
        </button>
      </div>
    </>
  );
};

export default compose(
  settingable("background"),
  connectActions(table)
)(CellSettings);
